import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/**
 * @internal
 */
function formData() {
    NoTransformConfigurationError("http.formData");
}
/**
 * @internal
 */
function assertFormData() {
    NoTransformConfigurationError("http.assertFormData");
}
/**
 * @internal
 */
function isFormData() {
    NoTransformConfigurationError("http.isFormData");
}
/**
 * @internal
 */
function validateFormData() {
    NoTransformConfigurationError("http.validateFormData");
}
/**
 * @internal
 */
function query() {
    NoTransformConfigurationError("http.query");
}
/**
 * @internal
 */
function assertQuery() {
    NoTransformConfigurationError("http.assertQuery");
}
/**
 * @internal
 */
function isQuery() {
    NoTransformConfigurationError("http.isQuery");
}
/**
 * @internal
 */
function validateQuery() {
    NoTransformConfigurationError("http.validateQuery");
}
/**
 * @internal
 */
function headers() {
    NoTransformConfigurationError("http.headers");
}
/**
 * @internal
 */
function assertHeaders() {
    NoTransformConfigurationError("http.assertHeaders");
}
/**
 * @internal
 */
function isHeaders() {
    NoTransformConfigurationError("http.isHeaders");
}
/**
 * @internal
 */
function validateHeaders() {
    NoTransformConfigurationError("http.validateHeaders");
}
/**
 * @internal
 */
function parameter() {
    NoTransformConfigurationError("http.parameter");
}
/**
 * @internal
 */
function createFormData() {
    NoTransformConfigurationError("http.createFormData");
}
/**
 * @internal
 */
function createAssertFormData() {
    NoTransformConfigurationError("http.createAssertFormData");
}
/**
 * @internal
 */
function createIsFormData() {
    NoTransformConfigurationError("http.createIsFormData");
}
/**
 * @internal
 */
function createValidateFormData() {
    NoTransformConfigurationError("http.createValidateFormData");
}
/**
 * @internal
 */
function createQuery() {
    NoTransformConfigurationError("http.createQuery");
}
/**
 * @internal
 */
function createAssertQuery() {
    NoTransformConfigurationError("http.createAssertQuery");
}
/**
 * @internal
 */
function createIsQuery() {
    NoTransformConfigurationError("http.createIsQuery");
}
/**
 * @internal
 */
function createValidateQuery() {
    NoTransformConfigurationError("http.createValidateQuery");
}
/**
 * @internal
 */
function createHeaders() {
    NoTransformConfigurationError("http.createHeaders");
}
/**
 * @internal
 */
function createAssertHeaders() {
    NoTransformConfigurationError("http.createAssertHeaders");
}
/**
 * @internal
 */
function createIsHeaders() {
    NoTransformConfigurationError("http.createIsHeaders");
}
/**
 * @internal
 */
function createValidateHeaders() {
    NoTransformConfigurationError("http.createValidateHeaders");
}
/**
 * @internal
 */
function createParameter() {
    NoTransformConfigurationError("http.createParameter");
}

export { assertFormData, assertHeaders, assertQuery, createAssertFormData, createAssertHeaders, createAssertQuery, createFormData, createHeaders, createIsFormData, createIsHeaders, createIsQuery, createParameter, createQuery, createValidateFormData, createValidateHeaders, createValidateQuery, formData, headers, isFormData, isHeaders, isQuery, parameter, query, validateFormData, validateHeaders, validateQuery };
//# sourceMappingURL=http.mjs.map
